module.exports = __webpack_public_path__ + "images/stage.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stage.svg
// module id = 955
// module chunks = 0